/* Fitrax Volt — global.js */
(function () {
  'use strict';

  document.addEventListener('DOMContentLoaded', function () {
    initNavToggle();
    initCurrencySelector();
    initProductGallery();
    initSortSelect();
    initAddressForms();
  });

  /* Mobile nav */
  function initNavToggle() {
    var toggle = document.querySelector('[data-nav-toggle]');
    var drawer = document.querySelector('[data-nav-drawer]');
    if (!toggle || !drawer) return;
    toggle.addEventListener('click', function () {
      var open = drawer.classList.toggle('open');
      toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
    });
  }

  /* Country / currency selector */
  function initCurrencySelector() {
    var root = document.querySelector('[data-cur]');
    if (!root) return;
    var btn = root.querySelector('[data-cur-btn]');
    var panel = root.querySelector('[data-cur-panel]');
    var search = root.querySelector('[data-cur-search]');
    var empty = root.querySelector('[data-cur-empty]');
    if (!btn || !panel) return;

    function setOpen(open) {
      panel.classList.toggle('open', open);
      btn.setAttribute('aria-expanded', open ? 'true' : 'false');
      if (open && search) search.focus();
    }

    btn.addEventListener('click', function (e) {
      e.stopPropagation();
      setOpen(!panel.classList.contains('open'));
    });
    panel.addEventListener('click', function (e) { e.stopPropagation(); });
    document.addEventListener('click', function () { setOpen(false); });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') setOpen(false);
    });

    if (search) {
      search.addEventListener('input', function () {
        var q = search.value.trim().toLowerCase();
        var shown = 0;
        panel.querySelectorAll('.opt').forEach(function (opt) {
          var hay = opt.getAttribute('data-filter') || '';
          var match = !q || hay.indexOf(q) > -1;
          opt.style.display = match ? '' : 'none';
          if (match) shown++;
        });
        if (empty) empty.hidden = shown !== 0;
      });
    }
  }

  /* Product gallery thumbnails */
  function initProductGallery() {
    var gallery = document.querySelector('[data-gallery]');
    if (!gallery) return;
    var main = gallery.querySelector('[data-main-image]');
    var thumbs = gallery.querySelectorAll('[data-thumb]');
    if (!main || !thumbs.length) return;
    thumbs.forEach(function (thumb) {
      thumb.addEventListener('click', function () {
        main.src = thumb.getAttribute('data-full');
        thumbs.forEach(function (t) { t.classList.remove('active'); });
        thumb.classList.add('active');
      });
    });

    /* Update price + button state on variant change */
    var select = document.querySelector('[data-variant-select]');
    var priceEl = document.querySelector('[data-price]');
    if (select && priceEl) {
      select.addEventListener('change', function () {
        var opt = select.options[select.selectedIndex];
        if (!opt) return;
        var price = opt.getAttribute('data-price');
        var compare = opt.getAttribute('data-compare');
        if (price) {
          priceEl.innerHTML = compare
            ? '<span class="price-wrap"><s class="price-compare">' + compare + '</s><span class="price price-sale">' + price + '</span><span class="badge-sale">Sale</span></span>'
            : '<span class="price-wrap"><span class="price">' + price + '</span></span>';
        }
        var addBtn = document.querySelector('.product-form [name="add"]');
        if (addBtn) {
          var soldOut = opt.disabled;
          addBtn.disabled = soldOut;
          addBtn.textContent = soldOut ? 'Sold out' : 'Add to cart';
        }
      });
    }
  }

  /* Collection sorting */
  function initSortSelect() {
    var select = document.querySelector('[data-sort-select]');
    if (!select) return;
    select.addEventListener('change', function () {
      var url = new URL(window.location.href);
      url.searchParams.set('sort_by', select.value);
      url.searchParams.delete('page');
      window.location.href = url.toString();
    });
  }

  /* Address country/province selects */
  function initAddressForms() {
    document.querySelectorAll('[data-address-country]').forEach(function (countrySelect) {
      var wrapper = countrySelect.parentElement.querySelector('[data-province-wrapper]') ||
        (countrySelect.closest('form') && countrySelect.closest('form').querySelector('[data-province-wrapper]'));
      var provinceSelect = countrySelect.closest('form') &&
        countrySelect.closest('form').querySelector('[data-address-province]');
      if (!provinceSelect) return;

      function updateProvinces() {
        var opt = countrySelect.options[countrySelect.selectedIndex];
        var raw = opt ? opt.getAttribute('data-provinces') : null;
        var provinces = [];
        try { provinces = raw ? JSON.parse(raw) : []; } catch (e) { provinces = []; }
        provinceSelect.innerHTML = '';
        if (!provinces.length) {
          if (wrapper) wrapper.style.display = 'none';
          return;
        }
        provinces.forEach(function (p) {
          var o = document.createElement('option');
          o.value = p[0];
          o.textContent = p[1];
          provinceSelect.appendChild(o);
        });
        var def = provinceSelect.getAttribute('data-default');
        if (def) provinceSelect.value = def;
        if (wrapper) wrapper.style.display = '';
      }

      var defCountry = countrySelect.getAttribute('data-default');
      if (defCountry) countrySelect.value = defCountry;
      countrySelect.addEventListener('change', updateProvinces);
      updateProvinces();
    });
  }
})();
